import React from 'react'
import './styles.scss'
import NumberFormat from 'react-number-format'

export class CandidatesRows extends React.Component {
  render() {
    const candidates = this.props.limit
      ? this.props.candidates.slice(0, this.props.limit)
      : this.props.candidates

    const alreadyWonFirstRound = candidate => {
      return (
        candidate['attends round 1'] &&
        candidate['elected round 1'] &&
        this.props.round === 2
      )
    }
    return (
      <div className='candidates'>
        {candidates.map((candidate, i) => {
          let votes = null
          if (alreadyWonFirstRound(candidate)) {
            votes = 'Gewählt' + ' im 1. Wahlg.'
          } else if (candidate['votes round ' + this.props.round]) {
            votes = (
              <NumberFormat
                value={+candidate['votes round ' + this.props.round]}
                displayType='text'
                thousandSeparator="'"
              />
            )
          } else {
            votes = (
              <svg
                style={{
                  margin: 'auto',
                  background: 'none',
                  display: 'inline-block'
                }}
                width='18px'
                height='18px'
                viewBox='0 0 100 100'
                preserveAspectRatio='xMidYMid'
              >
                <path
                  fill='none'
                  d='M50 32.5A17.5 17.5 0 0 1 50 67.5A17.5 17.5 0 0 1 50 32.5'
                  stroke='#d8d8d8'
                  strokeWidth='35'
                >
                  <animate
                    attributeName='stroke-dasharray'
                    repeatCount='indefinite'
                    dur='5'
                    values='0 0 0 110;0 0 110 110;0 110 110 110'
                    keyTimes='0;0.5;1'
                    keySplines='0.5 0 0.5 1;0.5 0 0.5 1'
                    calcMode='spline'
                  />
                  <animate
                    attributeName='stroke'
                    values='#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8;#d8d8d8'
                    keyTimes='0;0.25;0.5;0.75;1'
                    dur='20s'
                    calcMode='discrete'
                    repeatCount='indefinite'
                  />
                </path>
              </svg>
            )
          }

          return (
            <div className='candidate' key={'candidate-' + i}>
              <div
                className='picture'
                style={{
                  backgroundColor: candidate.color,
                  backgroundImage:
                    'url(' +
                    (candidate['picture url'] ||
                      require('images/portrait.svg')) +
                    ')'
                }}
              />
              <div className='result'>
                <div className='name'>
                  {candidate['first name']} {candidate['last name']}{' '}
                  {candidate.outgoing ? '(bisher)' : ''}
                </div>
                <div
                  className={
                    'bar-wrapper' +
                    (candidate['votes round ' + this.props.round]
                      ? ''
                      : ' no-data') +
                    (alreadyWonFirstRound(candidate) ? ' won-first-round' : '')
                  }
                >
                  <div className='party'>{candidate.party}</div>
                  {!alreadyWonFirstRound(candidate) && (
                    <div className='bar-container'>
                      {this.props.absMajority > 0 && (
                        <>
                          {window.innerWidth > 500 &&
                            i === 0 &&
                            this.props.showClearMajorityLabel && (
                              <div
                                className='clear-majority-label'
                                style={{
                                  left:
                                    (this.props.absMajority /
                                      this.props.validVotes) *
                                      100 +
                                    '%'
                                }}
                              >
                                <svg
                                  width='13'
                                  height='21'
                                  viewBox='0 0 13 21'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path d='M5.3606 20.9802C5.62579 21.0572 5.90319 20.9046 5.98018 20.6394L7.23482 16.3178C7.31181 16.0527 7.15925 15.7753 6.89405 15.6983C6.62886 15.6213 6.35147 15.7738 6.27447 16.039L5.15924 19.8804L1.31785 18.7652C1.05266 18.6882 0.775263 18.8408 0.698272 19.106C0.621281 19.3711 0.773848 19.6485 1.03904 19.7255L5.3606 20.9802ZM12.5001 0.5C8.08236 0.5 4.77831 3.01278 3.32057 6.82126C1.86969 10.6118 2.25701 15.6412 5.0619 20.741L5.93811 20.259C3.243 15.3588 2.93034 10.6382 4.25449 7.17874C5.57177 3.73722 8.51775 1.5 12.5001 1.5V0.5Z' />
                                </svg>
                                absolutes Mehr
                              </div>
                            )}
                          <div
                            className='clear-majority'
                            style={{
                              left:
                                (this.props.absMajority /
                                  this.props.validVotes) *
                                  100 +
                                '%'
                            }}
                          />
                        </>
                      )}
                      <div
                        className='bar-active'
                        style={{
                          backgroundColor: candidate.color,
                          width:
                            (candidate['votes round ' + this.props.round] /
                              this.props.validVotes) *
                              100 +
                            '%'
                        }}
                      />
                      <div className='bar-background' />
                    </div>
                  )}
                  <div className='votes'>{votes}</div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

export default CandidatesRows
